import { Body_2, Markdown, useThemeContext } from '@huggg/react-components';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './message-bubble.module.scss';

export const MessageBubble = ({
  message,
  onAnimationComplete,
  animate = true,
  extraHeight = '0px',
  fromSelf = false,
}) => {
  const [isTypingAnimation, setIsTypingAnimation] = useState(animate);
  const {
    reaction: { colors },
  } = useThemeContext();

  const color = fromSelf ? colors.sent : colors.received;

  const renderTypingAnimation = () => (
    <div className={styles.dots}>
      <span className={styles.dot}>&#9679;</span>
      <span className={styles.dot}>&#9679;</span>
      <span className={styles.dot}>&#9679;</span>
    </div>
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTypingAnimation(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const renderMessage = () => (
    <div
      className={classnames(
        styles.message,
        isTypingAnimation ? styles.hide : styles.show,
      )}
      onTransitionEnd={() => {
        if (onAnimationComplete && animate && !isTypingAnimation) {
          setTimeout(() => {
            onAnimationComplete();
          }, 1000); // Delay of 1000ms (1 second)
        }
      }}
    >
      {!isTypingAnimation && <Markdown value={message} centerText />}
      <div className={styles.extraHeight} style={{ height: extraHeight }} />
    </div>
  );

  return (
    <Body_2 className={styles.container}>
      <svg
        viewBox="0 0 10 10"
        className={styles.bubbleArrow}
        fill={color}
        style={{
          transform: `scaleX(${fromSelf ? -1 : 1})`,
          left: fromSelf ? 'calc(100% - 25%)' : '25%',
        }}
      >
        <polygon points="0,0 10,10 0,10 0,0" />
      </svg>
      <div className={styles.bubble} style={{ backgroundColor: color }}>
        {isTypingAnimation && renderTypingAnimation()}
        {renderMessage()}
      </div>
    </Body_2>
  );
};
